import { useFormikContext } from 'formik'
import React from 'react'

import { Chip } from '@ui/components/Chip'

import type { WalletDepositFormValues } from '@model/WalletDepositFormValues'

import { HorizontalScroll } from '@global/HorizontalScroll/HorizontalScroll'

import { Box } from '../Box'

export enum CURRENCY_TYPE {
  EUR = 'EUR',
  USD = 'USD',
  GBP = 'GBP',
  CHF = 'CHF',
  ZAR = 'ZAR',
  PLN = 'PLN',
  HKD = 'HKD',
  SGD = 'SGD',
}

interface CurrencyAmountChipProps {
  minValue?: number
  onSelect?: (value: number) => void
}

export const CurrencyAmountChip: React.FC<CurrencyAmountChipProps> = ({
  minValue = 0,
  onSelect,
}) => {
  const { values, setFieldValue, setTouched } = useFormikContext<WalletDepositFormValues>()
  const presets = values.paymentProvider?.parameters?.presets ?? []
  const availablePresets = presets.filter((value) => value >= minValue)

  if (availablePresets.length === 0) return null

  return (
    <HorizontalScroll scrollBehavior='preserve'>
      <Box flex direction='row' gap='x8' justify='center' fullWidth>
        {availablePresets.map((value) => (
          <Box key={value}>
            <Chip
              selected={values.amount === value}
              onMouseDown={(event) => event.preventDefault()}
              onClick={async () => {
                await setFieldValue('amount', value)
                setTouched({ amount: true })
                onSelect?.(value)
              }}
            >
              {value}
            </Chip>
          </Box>
        ))}
      </Box>
    </HorizontalScroll>
  )
}
